import { loader } from 'graphql.macro';

export const createNew = loader('./CreateNew.gql');
export const teardown = loader('./Teardown.gql');

// cache busting comment hash 23947632875
